import classNames from 'classnames';
import React from 'react';
import styles from './Label.module.scss';
function Label({ as: Tag = 'h3', size = 'm', color = 'default', weight = 'strong', children, }) {
    const classes = classNames(styles.wrap, styles[size], styles[color], styles[weight]);
    return React.createElement(Tag, { className: classes }, children);
}
export default Label;
